import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Property} from "../../../model/property";

@Component({
  selector: 'app-property-information',
  templateUrl: './property-information.component.html',
  styleUrls: ['./property-information.component.css']
})
export class PropertyInformationComponent implements OnInit {

  @Input() informationProperty: Property;
  @Input() showPropertyInformationModal: boolean;
  @Input() showBillingAndBeneficiary: boolean = true;
  @Output() modalClosed = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  closeModal(){
    this.modalClosed.emit();
  }

}
